/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const MetadataBadge16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M8 1a7 7 0 110 14A7 7 0 018 1zm0 1a6 6 0 100 12A6 6 0 008 2zm2.456 3.794l.03.085 1 4a.5.5 0 01-.941.328l-.03-.086-.727-2.903-1.372 2.06a.5.5 0 01-.772.073l-.06-.074-1.373-2.059-.726 2.903a.5.5 0 01-.517.378l-.09-.014a.5.5 0 01-.377-.517l.014-.09 1-4a.5.5 0 01.845-.226l.056.07L8 8.098l1.584-2.374a.5.5 0 01.872.07z"
        />
    </AccessibleSVG>
);

export default MetadataBadge16;
